module.exports = __webpack_public_path__ + "assets/images/32b1ad53ca02a15f6b6bbd1f5812b065.png";